// #############################################################
// IMPORTS
// - jquery
// - bootstrap
//
// MODULES
// - MD modal
// - MD swiper
// - MD tabs
// - MD flyout
//
// FUNCTIONS
// - FN ***
//
// OTHER
// - ***
//
// WHEN COMPLETE
// - ***
//
// #############################################################

// =============================================================
// IMPORTS
// =============================================================
// https://docs.typo3.org/m/typo3/reference-coreapi/main/en-us/ApiOverview/Backend/JavaScript/ES6/Index.html
import $ from "jquery";

let breadcrumbs = $(".breadcrumbs");

// =============================================================
// MODULES
// =============================================================

if ($(".link--modal").length > 0) {
  import("./modules/link-modal.module.js").then((module) => {
    module.init();
  });
}
if ($(".modal").length > 0) {
  import("./modules/modal.module.js").then((module) => {
    module.init();
  });
}

if ($(".swiper-container--1").length > 0) {
  import("./modules/swiper/container-1.module.js").then((module) => {
    module.init();
  });
}

if ($(".swiper-container--2").length > 0) {
  import("./modules/swiper/container-2.module.js").then((module) => {
    module.init();
  });
}

if ($(".banner-swiper-container").length > 0) {
  import("./modules/swiper/container-3.module.js").then((module) => {
    module.init();
  });
}

if ($('section [role="tab"]').length > 0) {
  import("./modules/tabs.module.js").then((module) => {
    module.init();
  });
}

if ($(".main-nav").length > 0) {
  import("./modules/main-nav.module.js").then((module) => {
    module.init();
  });
}

if ($(".collapse").length > 0) {
  import("./modules/panel.module.js").then((module) => {
    module.init();
  });
}

if ($("#map-project-places, #map-places").length > 0) {
  import("./modules/map.module.js").then((module) => {
    module.init();
  });
}

if ($("#project-filters").length > 0) {
  import("./modules/project-search.module.js").then((module) => {
    module.init();
  });
}

if ($(".powermail_morestep").length > 0) {
  import("./modules/morestep-form.module.js").then((module) => {
    module.init();
  });
}

if ($(".ctype-ce_news_search").length > 0) {
  import("./modules/ce-news-search.module.js").then((module) => {
    module.init();
  });
}

if ($(".ctype-ce_keyword_search").length > 0) {
  import("./modules/ce-keyword-search.module.js").then((module) => {
    module.init();
  });
}

if ($(".tx_ascontenttracker").length > 0) {
  import("./modules/as-contenttracker.module.js").then((module) => {
    module.init();
  });
}

if ($(".lightbox").length > 0) {
  import("./modules/magnific-popup.module.js").then((module) => {
    module.init();
  });
}

// =============================================================
// FUNCTIONS
// =============================================================

//
//
//

// =============================================================
// OTHER
// =============================================================

if (breadcrumbs.length > 0) $("body").addClass("has-breadcrumbs");

// =============================================================
// WHEN COMPLETE
// =============================================================
const whenComplete = () => {
  if (document.readyState === "complete") {
    let $header = $(".header");
    if (!$header) return; // If page hasn't default layout

    let scrollStart = $(".banner") ? 99 : 7;
    let isHeaderMini = false;
    let prevScreenWidth = window.innerWidth;

    // -------------------------------------------------------------
    // on listeners
    // -------------------------------------------------------------

    if ($header.length > 0) {
      // Scroll
      const scrollHandler = () => {
        let sc = window.scrollY || window.pageYOffset;

        if (sc > scrollStart) {
          if (isHeaderMini) return;
          $header.addClass("header--mini");
          isHeaderMini = true;
        } else {
          if ($header.hasClass("header--mini")) {
            $header.removeClass("header--mini");
            isHeaderMini = false;
          }
        }
      };

      $(window).on("scroll", scrollHandler);

      // On page load with offset
      if ((window.scrollY || window.pageYOffset) > 159) {
        $header.addClass("header--mini");
      }
    }

    // Resize
    // $(window).on("resize", function (e) {
    //   if (!e.isTrigger) {
    //     clearTimeout(this._timer);
    //     this._timer = setTimeout(() => {
    //       // Prevent from further operations for Google mobile browsers
    //       // (if event is not real screen change of a device)
    //       if (Math.abs(window.innerWidth - prevScreenWidth) < 99) return;
    //       prevScreenWidth = window.innerWidth;
    //       // console.log(
    //       //   "%cMain resize",
    //       //   "color:#6f6f6f;font-family:monospace;font-size:12px;"
    //       // );
    //     }, 400);
    //   }
    // });

    // Search handler for mobile screens
    // Search field with submit button are fading up when user clicks on a round search button
    $header
      .find('.form-header-search [data-js="header-search"]')
      .on("click", function (e) {
        if (prevScreenWidth > 767) return;
        e.preventDefault();
        let form = $(this).closest("form");
        form.toggleClass("form-header-search--active");
        form.prev().toggleClass("fade-out");
      });

    // Search focusin handler (tablets and desktops)
    // Search field becomes wider on focus event and search button is within search box
    $header.find(".form-header-search input").on("focusin", function (e) {
      if (prevScreenWidth < 768) return;
      e.preventDefault();
      let form = $(this).closest("form");
      if (form.hasClass("form-header-search--active")) return;
      form.addClass("form-header-search--active");
      form.prev().addClass("fade-out");
    });

    // Mobile search focusout handler (tablets and desktops)
    $header.find(".form-header-search input").on("focusout", function (e) {
      if (prevScreenWidth < 768) return;
      e.preventDefault();
      let form = $(this).closest("form");
      if (!form.hasClass("form-header-search--active")) return;
      form.removeClass("form-header-search--active");
      form.prev().removeClass("fade-out");
    });

    // -------------------------------------------------------------
  } else {
    setTimeout(function () {
      whenComplete();
    }, 400);
  }
};

whenComplete();

let styleAttempts = 0;
const stylesComplete = () => {
  if (styleAttempts > 30) return;
  styleAttempts += 1;

  if ($("#spreld").attr("rel") === "stylesheet") {
    $("#sess").remove();
  } else {
    setTimeout(function () {
      stylesComplete();
    }, 300);
  }
};
stylesComplete();
